import React, { useState } from 'react';
import { connect } from 'react-redux';
import FiltroSTP from './list-transactions-stp/components/FiltroSTP';
import { listSTPAction } from '_models/redux/list-transfer-stp/action';
import Grid from '@mui/material/Grid';
import { Typography, Box } from '@mui/material';
import { PageSTPHook } from './list-transactions-stp/hooks/PageSTPHook';
import DataTable from 'widgets/datagrid/DataTable';
import { detailSTPAction } from '_models/redux/detail-transactions-stp/action';
import { cleanTransferSTPClean } from '_models/redux/list-transfer-stp/clean-action';
import { cleanDetailSTPAction } from '_models/redux/detail-transactions-stp/clean-action';
import { actionReportTransactionsFraud } from '_models/redux/report-transaction-fraud/action';
import { actionReportTransactionsChargeback } from '_models/redux/report-transaction-chargeback/action';
import { cleanReportPrepaidChargebackDetails } from '_models/redux/report-transaction-chargeback/clean_action';
import { cleanReportTransactionsFraud } from '_models/redux/report-transaction-fraud/clean_action';
import STPMessageDialog from './components/STPMessageDialog';
import STPDetailsDialog from './components/STPDetailsDialog';
import STPFraudDialog from './components/STPFraudDialog';

const PageSTP = ({
  listSTPAction,
  cleanTransferSTPClean,
  listTransactionsSTP,
  detailSTPAction,
  cleanDetailSTPAction,
  detailsTransactionsSTP,
  reportTransactionsFraud,
  reportTransactionsChargeback,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  transactionId,
  onClose,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    isDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    openActionFraud,
    handleCloseFraudChargeback,
    setDescriptionTransaction,
    setError,
    error,
    loadingFraudAndChargeback,
    isError,
    handleConfirm,
    setOpenActionFraud,
    handleOpenPopUp,
  } = PageSTPHook({
    listSTPAction,
    cleanTransferSTPClean,
    listTransactionsSTP,
    detailSTPAction,
    cleanDetailSTPAction,
    detailsTransactionsSTP,
    reportTransactionsFraud,
    reportTransactionsChargeback,
    cleanReportPrepaidChargebackDetails,
    actionReportTransactionsChargeback,
    actionReportTransactionsFraud,
    cleanReportTransactionsFraud,
    transactionId,
    onClose,
  });

  const [hasSearched, setHasSearched] = useState(false);
  const onSubmitWithFlag = (...args) => {
    setHasSearched(true);
    return onSubmit(...args);
  };

  return (
    <>
      <Grid>
        <h4> Transacciones de STP </h4>
      </Grid>
      <Grid marginBottom={4}>
        <FiltroSTP
          onSubmit={onSubmitWithFlag}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Grid>
      <Grid>
        {mappedRows?.length > 0 ? (
          <Grid paddingRight={5} paddingLeft={0}>
            <Box>
              <DataTable
                rows={mappedRows}
                columns={Columns}
                onRowClick={handleRowClick}
                page={page}
                pageSize={size}
                rowCount={pagination?.total_rows ?? 0}
                onPageChange={pagination?.handleChangePage}
                handleChangePageSize={pagination?.handleChangePageSize}
                loading={loading}
              />
            </Box>
          </Grid>
        ) : (
          hasSearched && <Typography variant='h6'>No hay registros disponibles</Typography>
        )}
      </Grid>

      <STPDetailsDialog
        open={isDialogOpenDetails}
        onClose={handleClose}
        detailsTransactionsSTP={detailsTransactionsSTP}
        handleOpenPopUp={handleOpenPopUp}
        setOpenActionFraud={setOpenActionFraud}
      />

      <STPMessageDialog open={isDialogOpen} onClose={handleClose} dialogMessage={dialogMessage} />

      <STPFraudDialog
        open={openActionFraud}
        onClose={handleCloseFraudChargeback}
        handleConfirm={handleConfirm}
        setDescriptionTransaction={setDescriptionTransaction}
        setError={setError}
        error={error}
        loadingFraudAndChargeback={loadingFraudAndChargeback}
        dialogMessage={dialogMessage}
        isError={isError}
        reportTransactionsFraud={reportTransactionsFraud}
        reportTransactionsChargeback={reportTransactionsChargeback}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  listTransactionsSTP: state?.listTransactionsSTP,
  detailsTransactionsSTP: state?.detailsTransactionsSTP,
  reportTransactionsFraud: state?.reportTransactionsFraud,
  reportTransactionsChargeback: state?.reportTransactionsChargeback,
});

const mapDispatchToProps = {
  listSTPAction,
  cleanTransferSTPClean,
  detailSTPAction,
  cleanDetailSTPAction,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageSTP);
